import { workspaceToMenuItems } from "common/Home/Sider/Sider.tsx";
import { MenuItemConfig, WorkspaceToPathsMapping } from "types";
import { WorkspaceType } from "@shared/types";

const getMenuItemPathsArray = (menuItem: MenuItemConfig) => {
  if (menuItem.routerMatch) {
    if (Array.isArray(menuItem.routerMatch)) return menuItem.routerMatch;
    return [menuItem.routerMatch];
  }
  return [];
};

const getWorkspacePathsArray = (workspace: WorkspaceType) => {
  let workspaceMenuItemPaths: string[] = [];
  for (let menuItem of workspaceToMenuItems[workspace]) {
    workspaceMenuItemPaths = [
      ...workspaceMenuItemPaths,
      ...getMenuItemPathsArray(menuItem),
    ];
    if (menuItem.subMenu) {
      for (let subMenu of menuItem.subMenu) {
        workspaceMenuItemPaths = [
          ...workspaceMenuItemPaths,
          ...getMenuItemPathsArray(subMenu),
        ];
      }
    }
  }
  return workspaceMenuItemPaths;
};

export const getWorkspaceToPath = () => {
  let workspaceToPath: Partial<WorkspaceToPathsMapping> = {};
  for (let workspace of Object.keys(workspaceToMenuItems)) {
    workspaceToPath = {
      ...workspaceToPath,
      [workspace]: getWorkspacePathsArray(workspace as WorkspaceType),
    };
  }
  return workspaceToPath as WorkspaceToPathsMapping;
};
